import Nullstack from 'nullstack';
export default function IconCircuitSwitchOpen({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-circuit-switch-open",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M2 12h2"
  }), "   ", Nullstack.element("path", {
    d: "M20 12h2"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "12",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "12",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M7.5 10.5l7.5 -5.5"
  }), " ");
}